import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DocsLayout } from "@/components/docs/docs-layout";
import { findDocPage } from "@/components/docs/pages";
import { Wordmark } from "@/components/shell/brand";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/docs/$page")({
  component: DocsPage,
});

/** One page of the public documentation. The pages are listed in components/docs/pages.tsx. */
function DocsPage() {
  const { page: slug } = Route.useParams();
  const { t } = useTranslation("docs");
  const page = findDocPage(slug);

  if (!page) {
    return (
      <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-4 px-6">
        <Wordmark />
        <p className="text-muted-foreground">{t("ui.notFound")}</p>
        <div>
          <Button variant="outline" asChild>
            <Link to="/docs">{t("ui.docs")}</Link>
          </Button>
        </div>
      </main>
    );
  }

  return (
    <DocsLayout page={page}>
      <page.Content />
    </DocsLayout>
  );
}
